import { emailStepStore } from "@/entities/StepEmail/store/emailStepStore";
import { folderStepStore } from "@/entities/StepFolder/store/folderStepStore";
import { ManifestJsonDataFile } from "@features/FxLauncherLoader/utils/interfaces";
import { appStore } from "@/app/store/appStore";
import { VERSIONS } from "@entities/UpdateComponent/UpdateComponent";
import { killProcess } from "@features/StepsContent/components/StepStart/KillProcess";
import FilesystemRoot = FxApi.File.FilesystemRoot;
import { persistStore } from "@entities/StepFolder/store/persistStore";

export const delay = function (ms: number) {
	return new Promise((res) => {
		setTimeout(res, ms);
	});
};

export async function findSubProcess(): Promise<{ id: number; name: string }[]> {
	try {
		const version = appStore.getState().appVersion;
		if (version > VERSIONS.NEW_SUB_PROCESS_START) {
			const currentProcessName = await FxApi.Process.getCurrentModulePath();
			const listChildProcesses = await FxApi.Process.listChildProcesses();
			return listChildProcesses.filter(
				(process) =>
					process.name &&
					process.name !== currentProcessName.path &&
					process.name.indexOf("crashpad_handler.exe") < 0
			);
		} else {
			const processListChildIds = (await FxApi.Process.listChildProcesses()).map((process) => process.id);
			const processList = await FxApi.Process.listProcesses();
			return processList.filter((process) => processListChildIds.indexOf(process.parentId) >= 0);
		}
	} catch (error) {
		console.log("await FxApi.Process.listProcesses => ", error);
	}
	return [];
}

export async function KillProcessAndChildren(processCandidate: { id: number; name: string }) {
	if (processCandidate.id === -1) {
		console.log("KillProcessAndChildren with invalid process id");
		return;
	}
	const children = (await FxApi.Process.listProcesses()).filter((p) => p.parentId === processCandidate.id);

	for (const childProcess of children) {
		KillProcessAndChildren(childProcess);
	}
	try {
		await killProcess(processCandidate.id);
	} catch (error) {
		console.log(" await findProcess(cmd);", error);
	}
}
export async function killAllSubProcess(): Promise<boolean> {
	while (true) {
		const process = await findSubProcess();

		for (const processCandidate of process) {
			await KillProcessAndChildren(processCandidate);
		}
		console.log(process);
		if (process.length === 0) {
			return true;
		}
	}
}

function convertLanguageCode(code: string): string {
	const languageMap: { [key: string]: string } = {
		en: "english",
		de: "german",
		es: "spanish",
		fa: "arabic",
		fr: "french",
		it: "italian",
		ja: "japanese",
		ko: "korean",
		pt: "portuguese",
		ru: "russian",
		tr: "turkish",
		zh: "chineses", // для aw вариант - так то должно быть 'chinese'
		uk: "ukrainian",
		pl: "polish"
	};

	return languageMap[code] || "english";
}

/**
 * Converts Steam API language codes to standard web language codes (ISO 639-1 with optional region tags)
 * @param steamLanguage The language code from Steam API (e.g., 'brazilian', 'schinese')
 * @returns The corresponding web language code (e.g., 'pt-BR', 'zh-CN')
 */
export function convertSteamLanguageToWeb(steamLanguage: string): string {
	const languageMap: { [key: string]: string } = {
		'arabic': 'ar',
		'bulgarian': 'bg',
		'schinese': 'zh-CN',    // Simplified Chinese
		'tchinese': 'zh-TW',    // Traditional Chinese
		'czech': 'cs',
		'danish': 'da',
		'dutch': 'nl',
		'english': 'en',
		'finnish': 'fi',
		'french': 'fr',
		'german': 'de',
		'greek': 'el',
		'hungarian': 'hu',
		'italian': 'it',
		'japanese': 'ja',
		'korean': 'ko',
		'norwegian': 'no',
		'polish': 'pl',
		'portuguese': 'pt-PT',
		'brazilian': 'pt-BR',    // Brazilian Portuguese
		'romanian': 'ro',
		'russian': 'ru',
		'spanish': 'es',
		'latam': 'es-419',      // Latin American Spanish
		'swedish': 'sv',
		'thai': 'th',
		'turkish': 'tr',
		'ukrainian': 'uk',
		'vietnamese': 'vi'
	};

	const normalizedInput = steamLanguage.toLowerCase().trim();
	return languageMap[normalizedInput] || 'en'; // Default to English if code not found
}

export const fillCommandLineParams = (() => {
	const replacers = [
		[/{original_command_line_param}/g, () => (FxApi.getCommandLine() || "").replace(/".*?"\s*/, "")],
		[/{token_name}/g, "fxid-login-token"],
		[/{token_value}/g, () => emailStepStore.getState().responseData?.Tokens?.GameAccessToken || ""],
		[/{email}/g, () => encodeURI(emailStepStore.getState().email || "")],
		[/{launchParams}/g, () => folderStepStore.getState().appProfile?.LauncherConfiguration?.LaunchParams || ""],
		[/{language}/g, () => persistStore.getState().language],
		[/{languageName}/g, () => convertLanguageCode(persistStore.getState().language)],
		[/{server}/g, () => persistStore.getState().preferredServer],
		[/{twitch_token}/g, () => persistStore.getState().twitchToken||""]
	] as const;

	return (params: string): string =>
		replacers.reduce(
			(acc, [regex, replacer]) =>
				acc.match(regex) ? acc.replace(regex, typeof replacer === "function" ? replacer() : replacer) : acc,
			params
		);
})();

export async function waitForSubProcess(filter?: string | null) {
	await delay(4000);
	while (true) {
		let processStarted = await findSubProcess();
		//console.log(`processStarted: ${filter}  ${JSON.stringify(processStarted)}`);
		if (filter) {
			processStarted = processStarted.filter((p) => p.name.toLowerCase().includes(filter.toLowerCase()));
		}

		if (processStarted.length < 1) {
			break;
		}
		await delay(5000);
	}
}

export async function waitForProcess(filter?: string | null) {
	await delay(4000);
	while (true) {
		let processStarted = await FxApi.Process.listProcesses();
		if (filter) {
			processStarted = processStarted.filter((p) => p.name.toLowerCase().includes(filter.toLowerCase()));
		}

		if (processStarted.length < 1) {
			break;
		}
		await delay(5000);
	}
}


export async function waitForProcessWindow(processId: number) {
	await delay(4000);
	while (true) {
		const windows = await FxApi.Process.listProcessWindows(processId);
		if (windows.length==0) {
			break;;

		}
		await delay(5000);
	}
}



export function convertManifestPathToFxApiPath(file: ManifestJsonDataFile, base: string[] = ["APP"]) {
	const filePath: string[] = file.path.split("/");
	base.forEach((b) => filePath.unshift(b));
	return filePath;
}
export function convertPathToArrayNoRoot(path: string): string[] {
	const filePath: string[] = path.replaceAll("\\", "/").split("/");
	filePath[0] += "/";
	return filePath;
}

// ["D:\\Games\\aw\\_cache\\gamesdk\\Levels\\TST\\TEST_Anzu\\level.pak\\0025c4882406e76cc6bfa829207c3859fab2f558ca742ac1d7b99f1bc3e46b6b"
export function convertPathToArray(path: string, roots: Record<FilesystemRoot, string>): string[] {
	const filePath: string[] = path
		.replace(roots.APP, "APP")
		.replace(roots.CACHE, "CACHE")
		.replace(roots.TMP, "TMP\\")
		.replace(roots.APP_DATA, "APP_DATA")
		.replace(roots.WIN, "WIN")
		.replace(roots.HOME, "HOME")
		.replaceAll("\\", "/")
		.split("/");
	return filePath;
}

export async function packFolderZip(path: string[], to: string[], onPack?: (file: string[]) => void) {
	try {
		const roots = folderStepStore.getState().roots;
		const {files, dirs} = await FxApi.File.getList(path);
		for (let i = 0; i < files.length; i += 1) {
			const file = files[i];
			const filePath = convertPathToArray(file, roots);
			const pathInZip = filePath.slice(3).map((x) => x.toLowerCase()); //.slice(Math.max(3, filePath.length-3));// ['out',filePath[filePath.length-1]]

			try {
				await FxApi.Zip.addToArchive(to, filePath, pathInZip);
				//console.log("Adding file:", to, filePath, pathInZip, res);
			} catch (e) {
				console.log("Failed to zip ", to, filePath, pathInZip, e);
			}

			if (onPack) onPack(filePath);
		}
		for (let i = 0; i < dirs.length; i += 1) {
			const dir = dirs[i];
			const pathDir = convertPathToArray(dir, roots);
			await packFolderZip(pathDir, to, onPack);
		}
	}
	catch (e)
	{
		console.log("failed packing folder:", path,e);
	}
}

export async function deleteAllFilesAndFolders(path: string[],onDelete?: (file: string[]) => void) {
	const files = await FxApi.File.getList(path);
	for (let i = 0; i < files.files.length; i += 1) {
		const file = files.files[i];

		try {
			const filePath = convertPathToArrayNoRoot(file);

			await FxApi.File.deleteFile(filePath);
			if(onDelete)onDelete(filePath);
			console.log(`Deleted file: ${filePath}`);
		} catch (error) {
			console.log(`Error deleting file: ${error}`);
		}
	}
	for (let i = 0; i < files.dirs.length; i += 1) {
		const folder = files.dirs[i];
		try {
			const folderPath = convertPathToArrayNoRoot(folder);

			await deleteAllFilesAndFolders(folderPath,onDelete);
			console.log(`deleteAllFilesAndFolders folder: ${folderPath}`);
		} catch (error) {
			console.log(`Error deleting folder: ${error}`);
		}
	}
	try {
		await FxApi.File.deleteFolder(path);
	}
	catch (e)
	{
		console.log(e);
	}
}

async function stopStaleDownloads() {
	const downloads = await FxApi.Download.listDownloads();
	for (const download of downloads) {
		const state = await FxApi.Download.getDownloadState(download);
	//	if (state.bps < 100) {
			console.log(
				`Deleting download: ${download} - ${state.bps}bps - ${state.downloaded}downloaded ${state.total}total - ${state.finished}`
			);
			await FxApi.Download.removeDownload(download);
		// }
		// else
		// {
		// 	console.log(`Keeping download: ${download} - ${state.bps}bps - ${state.downloaded}downloaded ${state.total}total - ${state.finished}`);
		// }
	}
	await delay(1000);
}

export async function loadFileWithSHA256(
	downloadToPath: string[],
	url: string,
	sha256: string,
	attemptsToRun: number = 0
): Promise<boolean> {
	let attempt = attemptsToRun;
	if (attempt > 20) {
		console.log(`too many attempts to load ${url} - resigning`);
		return false;
	}
	await delay(attempt * 100);
	attempt += 1;

	try {
		const info = await FxApi.File.getFileInfo(downloadToPath);
		console.log(url);
		if (!info.exist) {
			try {
				await FxApi.File.createFolder(downloadToPath.slice(0, downloadToPath.length - 1));
				// console.log(`FxApi.Curl.downloadFile(${url}, ${downloadToPath})`
				// )
				// const res = await FxApi.Curl.downloadFile(url, downloadToPath);
				// console.log(`Downloaded ${url} to ${downloadToPath} ${res.success}`);


				const downloadId = await FxApi.Download.addDownload(encodeURI(url), downloadToPath);
				while (true) {
					const downloadState = await FxApi.Download.getDownloadState(downloadId);
					//console.log(downloadState);
					if (downloadState.finished) {
						break;
					}

					await delay(100);
				}
				await loadFileWithSHA256(downloadToPath, url, sha256, attempt);
			} catch (error) {
				console.error("loadFileWithSHA256 2 error: ", error);
				await stopStaleDownloads();
				await loadFileWithSHA256(downloadToPath, url, sha256, attempt);
			}
		}
		const sha = await FxApi.File.getFileSHA256(downloadToPath);
		if (sha256 !== "skip" && sha256 !== sha.sha256) {
			try {
				const deleteResult = await FxApi.File.deleteFile(downloadToPath);
				console.log(
					`${JSON.stringify(deleteResult)} downloadToPath:${downloadToPath} sha256:${sha256} != sha.sha256:${sha.sha256}`
				);
			} catch (error) {
				console.error(`loadFileWithSHA256 error: ${error}`);
			}
			return await loadFileWithSHA256(downloadToPath, url, sha256, attempt);
		}

		return true;
	} catch (e) {
		console.log(e);
		throw new Error(`File locked: ${downloadToPath.join("/")} ${e}`);
	}
}

//
// function getProgressStep(progress: LoadingProgress): number {
//     if (progress.filesChecked) {
//         return 3;
//     }
//     if (progress.torrentLoaded) {
//         return 2;
//     }
//     if (progress.manifestChecked) {
//         return 1;
//     }
//     return 0;
// }

// interface RingProgressSection extends React.ComponentPropsWithRef<'circle'> {
//     value: number;
//     color: MantineColor;
//     tooltip?: React.ReactNode;
// }
